(function () {
  console.log("USPS register validation script loaded (v6)");

  async function validateUSPSOnRegister() {
    const form = document.getElementById("create_customer");
    if (!form) return;

    const streetEl = form.querySelector("#RegisterForm-StreetAddress");
    const zipEl    = form.querySelector("#RegisterForm-ZipCode");
    const cityEl   = form.querySelector("#RegisterForm-City");
    const stateEl  = form.querySelector("#RegisterForm-State");

    if (!streetEl || !zipEl || !cityEl || !stateEl) {
      console.warn("USPS validation: missing one or more fields");
      return;
    }

    const street = streetEl.value.trim();
    const city   = cityEl.value.trim();
    const state  = stateEl.value.trim();
    const zip    = zipEl.value.trim();

    if (!street || !city || !state || !zip) {
      console.warn("Skipping USPS (missing required fields)", { street, city, state, zip });
      return;
    }

    console.log("USPS payload:", { street, city, state, zip });

    try {
      const resp = await fetch("/apps/usps-validate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          StreetAddress: street,
          City: city,
          State: state,
          ZIPCode: zip
        })
      });

      const text = await resp.text();
      let data = {};
      try { data = JSON.parse(text); } catch { console.warn("USPS JSON parse failed:", text); }
      console.log("USPS API response:", data);

      if (!resp.ok) {
        console.warn("USPS returned non-200 status:", resp.status);
        return;
      }

      const a = data?.usps?.address;
      if (!a) {
        console.warn("No address object in USPS response");
        return;
      }

      // Normalize street
      const normalizedStreet = [
        a.streetAddress?.trim() || "",
        a.secondaryAddress?.trim() || ""
      ].filter(Boolean).join(" ");

      // Build ZIP+4 with flexible property handling
      const zip5 = a.ZIPCode || a.Zip5 || a.zip5 || "";
      const zip4 = a.ZIPPlus4 || a.ZIP4 || a.Zip4 || a.zip4 || "";

      let fullZip = zip5;
      if (zip5 && zip4) {
        fullZip = `${zip5}-${zip4}`;
      } else if (/^\d{5}-\d{4}$/.test(zip5)) {
        // already combined
        fullZip = zip5;
      }

      // Update the inputs
      if (normalizedStreet) {
        streetEl.value = normalizedStreet;
        streetEl.dispatchEvent(new Event("input", { bubbles: true }));
        streetEl.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (fullZip) {
        zipEl.value = fullZip;
        zipEl.dispatchEvent(new Event("input", { bubbles: true }));
        zipEl.dispatchEvent(new Event("change", { bubbles: true }));
      }

      console.log("USPS applied normalized values:", {
        street: normalizedStreet,
        zip: fullZip
      });
    } catch (err) {
      console.error("USPS register validation error:", err);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const zipEl = document.getElementById("RegisterForm-ZipCode");
    const cityEl = document.getElementById("RegisterForm-City");
    const stateEl = document.getElementById("RegisterForm-State");

    if (!zipEl || !cityEl || !stateEl) return;

    // Watch for autofill finishing (ZIP -> City/State)
    const observer = new MutationObserver(() => {
      const cityVal = cityEl.value?.trim();
      const stateVal = stateEl.value?.trim();
      if (cityVal && stateVal) {
        console.log("Detected ZIP autofill finished:", { cityVal, stateVal });
        observer.disconnect();
        setTimeout(validateUSPSOnRegister, 500);
      }
    });

    observer.observe(cityEl, { attributes: true, childList: true, subtree: true });
    observer.observe(stateEl, { attributes: true, childList: true, subtree: true });

    // Fallback: run USPS after ZIP blur if autofill already done
    zipEl.addEventListener("blur", () => {
      setTimeout(() => {
        const cityFilled = cityEl.value?.trim();
        const stateFilled = stateEl.value?.trim();
        if (cityFilled && stateFilled) {
          console.log("Running USPS validation after ZIP blur fallback");
          validateUSPSOnRegister();
        } else {
          console.log("Waiting for ZIP autofill...");
        }
      }, 1000);
    });
  });
})();
